import { initLoanFitUI } from './ui.js';

document.addEventListener('DOMContentLoaded', () => {
    const stateNode = document.getElementById('loan-fit-state-json');
    let state = { isAuthenticated: false };

    if (stateNode) {
        try {
            state = JSON.parse(stateNode.textContent || '{}');
        } catch (_error) {
            state = { isAuthenticated: false };
        }
    }

    initLoanFitUI(state);
});
